export default __webpack_public_path__ + "static/03.02-7ccb8b4c62febef188c7086dc6570284.png";